module.exports = __webpack_public_path__ + "img/IMG-20200519-WA0015.d1a807c8.jpg";